// Format stored reports as well as fresh responses, without altering their data.
export function weatherReportText(message, isGreek, translateText) {
  const negativeWind = String(message).match(/^(\d+) negative wind speed values clipped to 0\.$/);
  if (negativeWind) {
    const count = Number(negativeWind[1]);
    return isGreek
      ? count === 1
        ? '1 αρνητική τιμή ταχύτητας ανέμου διορθώθηκε σε 0 m/s.'
        : `${count} αρνητικές τιμές ταχύτητας ανέμου διορθώθηκαν σε 0 m/s.`
      : count === 1
        ? '1 negative wind speed value was corrected to 0 m/s.'
        : `${count} negative wind speed values were corrected to 0 m/s.`;
  }
  const timeBase = String(message).match(/^Time base: the source reports hours in UTC; they were shifted to local standard time by a fixed ([+-]?\d+(?:\.\d+)?) h offset \(([^)]+)\)\./);
  if (timeBase) {
    const [, offset, zone] = timeBase;
    return isGreek
      ? `Βάση χρόνου: οι ώρες UTC της πηγής μετατράπηκαν σε τοπική χειμερινή ώρα με σταθερή μετατόπιση ${offset} ωρών (${zone}). Δεν εφαρμόζεται θερινή ώρα. Η προσομοίωση χρησιμοποιεί την ίδια σύμβαση και ημερολόγιο 8.760 ωρών.`
      : `Time base: source hours in UTC were shifted to local standard time by a fixed ${offset} h offset (${zone}). Daylight saving is not applied. The simulation uses the same convention and an 8,760-hour calendar.`;
  }
  if (message === 'Leap-day (Feb 29) rows dropped to fit the 8760-hour TMY calendar.') {
    return isGreek
      ? 'Οι εγγραφές της 29ης Φεβρουαρίου αφαιρέθηκαν για προσαρμογή στο ημερολόγιο 8.760 ωρών της προσομοίωσης.'
      : 'February 29 rows were removed to fit the simulation’s 8,760-hour calendar.';
  }
  if (message === 'Pressure looked like hPa — converted to Pa (x100).') {
    return isGreek
      ? 'Οι τιμές πίεσης αναγνωρίστηκαν ως hPa και μετατράπηκαν σε Pa (×100).'
      : message;
  }
  return translateText(message);
}

export function weatherReportCount(warnings, notes, isGreek) {
  return [
    warnings > 0 && `${warnings} ${isGreek ? (warnings === 1 ? 'προειδοποίηση' : 'προειδοποιήσεις') : (warnings === 1 ? 'warning' : 'warnings')}`,
    notes > 0 && `${notes} ${isGreek ? (notes === 1 ? 'σημείωση' : 'σημειώσεις') : (notes === 1 ? 'note' : 'notes')}`,
  ].filter(Boolean).join(', ');
}
